import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Instructions from "./instructions";
import { checkPermissions } from "helpers/common";
import { getSettings, updatePromotionSettings } from "store/actions";
import LoadingButton from "../../../components/shared/LoadingButton";

const PromotionSettings = () => {
  const dispatch = useDispatch();
  const { settings, loading, error } = useSelector(({ Settings }) => Settings);
  const { user } = useSelector((state) => state.Auth);
  const [permissions, setPermissions] = useState({
    add: false,
    edit: false,
    delete: false,
  });

  useEffect(() => {
    if (user?.permissions) {
      setPermissions({
        add: false,
        edit: checkPermissions(["edit_promotion_settings"], user?.permissions),
        delete: false,
      });
    }
  }, [user]);

  const [fields, setFields] = useState({
    status: "disabled",
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (settings?._id) {
      const promotionBonus = settings?.promotionBonus;
      setFields(() => ({
        status: promotionBonus?.status,
      }));
    }
  }, [settings]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submit = async () => {
    dispatch(
      updatePromotionSettings({
        data: { ...fields },
      }),
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col sm={12} lg={12}>
              <Card>
                <CardBody className="spinner-content">
                  {error && typeof error === "string" ? (
                    <Alert color="danger">{error}</Alert>
                  ) : null}

                  {loading && <div className="spinner"></div>}

                  <Col lg={8}>
                    <Instructions />
                  </Col>

                  <Col lg={8}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="status"
                            className="form-control"
                            value={fields?.status}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>

                      <Col md={6} />
                      {permissions.edit ? (
                        <Col className="d-flex justify-content-end mt-3">
                          <LoadingButton
                            onClick={submit}
                            className="btn btn-primary btn-lg"
                            loading={loading}
                            disabled={loading}
                          >
                            {!loading ? <>Save Changes</> : ""}
                          </LoadingButton>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PromotionSettings;
